import { Drawer, Typography, useMediaQuery, useTheme } from '@mui/material'
import Grid from '@mui/material/Grid'
import classNames from 'classnames'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { RoutesArray } from 'ui/components/Navigation/types'

import DrawerItems from './DrawerItems/DrawerItems'
import styles from './Sidebar.module.less'

type SidebarProps = {
  desktopDrawerOpen: boolean
  mobileDrawerOpen: boolean
  setMobileDrawerOpen: (state: boolean) => void
  routes: RoutesArray
}

function Sidebar({ desktopDrawerOpen, mobileDrawerOpen, setMobileDrawerOpen, routes }: SidebarProps): ReactElement {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <>
      {isDesktop ? (
        <Drawer
          variant="permanent"
          className={classNames(styles.Sidebar_Drawer, {
            [styles.Sidebar_DrawerOpen]: desktopDrawerOpen,
            [styles.Sidebar_DrawerClose]: !desktopDrawerOpen,
          })}
          classes={{
            paper: classNames(styles.Sidebar_Root, {
              [styles.Sidebar_DrawerOpen]: desktopDrawerOpen,
              [styles.Sidebar_DrawerClose]: !desktopDrawerOpen,
            }),
          }}
          open={desktopDrawerOpen}
        >
          <DrawerItems routes={routes} drawerOpen={desktopDrawerOpen} />
          {desktopDrawerOpen && (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="flex-end"
              className={styles.Sidebar_VersionContainer}
            >
              <Typography className={styles.Sidebar_VersionText}>
                Aurora by Sigholm {moment().format(`YYYY`)}
              </Typography>
              <Typography className={styles.Sidebar_VersionText}>Version: Sideshow Bob</Typography>
            </Grid>
          )}
        </Drawer>
      ) : (
        <Drawer
          variant="temporary"
          anchor={theme.direction === `rtl` ? `right` : `left`}
          open={mobileDrawerOpen}
          onClose={() => setMobileDrawerOpen(false)}
          classes={{
            paper: classNames(styles.Sidebar_Root, styles.Sidebar_Drawer),
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <DrawerItems routes={routes} drawerOpen={true} onItemNavigate={() => setMobileDrawerOpen(false)} />
        </Drawer>
      )}
    </>
  )
}

export default React.memo(Sidebar)
